import React from 'react';
import ScheduleDisplay from '../components/ScheduleDisplay';
import PriceScreen from '../components/PriceScreen';
import PriceScreenCenter from '../components/PriceScreenCenter';
import jardinData from '../content/jardin-st-roch.json';
import AutoRefresh from '../components/AutoRefreshProps';

export function EventPageJSR() {
  return (
    <div
      style={{
        position: 'relative',
        height: '100vh',
        display: 'flex',
        background: 'linear-gradient(to left, #001C4C 50%, transparent 50%)'
      }}
    >
      <div style={{
        left: '2.5rem',
        position: 'absolute',
        zIndex: 10,
        top: '2.5rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem'
      }}>
        <img src={"/feq.png"} alt={"FEQ"} className={"h-[3vw] w-fit"} />
        <p className={'text-[3vw]'} style={{
          fontWeight: 'bold',
          lineHeight: 1,
          color: "white",
        }}>
          Farruko
        </p>
        <p className={'text-[1vw]'} style={{
          fontWeight: 500,
          lineHeight: 1,
          textTransform: 'uppercase',
          color: "white",
        }}>13 Juillet</p>
      </div>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 10,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(to left, #001C4C 40%, transparent 70%)'
      }}>
      </div>
      <div style={{
        position: 'relative',
        width: '66.666667%',
        height: '100%'
      }}>
        <img src={"/july13.png"} alt={"Rod Stewart"} style={{ objectFit: 'cover', position: "absolute", width: "100%", height: "100%" }} />
      </div>
      <div style={{
        width: '33.333333%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        textAlign: 'center',
        marginRight: '2.5rem',
        zIndex: 20
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem',
        }}>
          <p className={'text-[3vw] leading-none'} style={{
            fontWeight: 500,
            color: "white",
          }}>
            Tarif Évènement
          </p>
          <p className={'text-[1.5vw] leading-none'} style={{
            fontWeight: 500,
            color: "white",
          }}>
            Event price
          </p>
          <h1 className={'text-[10vw]'} style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
          }}>
                        <span style={{
                          lineHeight: 1,
                          fontWeight: 'bold',
                          color: "white",
                        }}>20</span>
            <span className={'text-[6vw]'} style={{
              fontWeight: 'bold',
              lineHeight: 1.25,
              color: "white",
            }}>
                            $
                        </span>
          </h1>
          <p className={'text-[3vw] mt-3'} style={{
            fontWeight: 500,
            color: "white",
          }}>
            Bonne soirée !
          </p>
        </div>
      </div>
    </div>
  )
}

function JardinStRoch() {

  //const [soldout, setSoldout] = useState(false);

  const dayContent = (
    <PriceScreen
      title={jardinData.day.title}
      lines={[
        jardinData.day.lines[0],
        jardinData.day.lines[1],
        jardinData.day.lines[2],
      ]}
    />
  );
  const nightContent = (
    <PriceScreenCenter
      title={jardinData.night.title}
      lines={jardinData.night.lines}
    />
  );

  /*useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('Soldout status:', "ALLO");

        const response = await fetch(
          `https://api.allorigins.win/get?url=${encodeURIComponent('https://www.parkwizeinc.com/api/organization/ef9189e4-57c3-4eba-98c1-2682d3b87fcb/parkings/58fcedbe-2b01-45f3-a01c-50d763cf811f/soldout')}`,
          {
            cache: "no-cache",
            method: 'GET',
            headers: {
              'Accept': 'application/json',
            },
          }
        );

        if (response.ok) {
          const result = await response.json();
          const data = JSON.parse(result.contents);
          console.log("SOLD OUT STATUS: ", data);
          return data.soldout as boolean;
        } else {
          console.error('Response not ok:', response.status, response.statusText);
          return false;
        }
      } catch (error) {
        console.error('Error fetching soldout status:', error);
        return false;
      }
    };

    const checkSoldoutStatus = async () => {
      const isSold = await fetchData();
      setSoldout(isSold);
      console.log('Soldout status updated:', isSold);
    };

    // Check immediately on component mount
    checkSoldoutStatus();

    // Set up interval to check every minute (60,000 ms)
    const interval = setInterval(() => {
      checkSoldoutStatus();
    }, 60 * 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  const screen = soldout ? <SoldOutScreen /> : nightContent;*/

  return (
    <div>
      <AutoRefresh intervalms={900000} /> {/* 15 min */}
      <ScheduleDisplay
        dayContent={dayContent}
        nightContent={nightContent}
        dayStartTime="00:00:00"
        nightStartTime="16:00:00" // 16:00:00
      />
    </div>
  );
}

export default JardinStRoch;
